// extracted by mini-css-extract-plugin
module.exports = {"shoppingSticker_wrapper":"styles_shoppingSticker_wrapper__ehtc3","shoppingSticker_img":"styles_shoppingSticker_img__UXibH"};